let sentryInitError = false;
let Sentry = null;

function isUwpApp() {
  const useragent = navigator.userAgent;
  return useragent.includes('WebView') && useragent.includes('Edge/18');
}

export const initSentry = async ({ Vue, router, dsn }) => {

  if (isUwpApp()){
    sentryInitError = true;
    throw new Error('uwp app cannot use sentry ( no spread operation support )');
  }

  // sentry has many spread operation , use dynamic import load sentry by condition
  Sentry = await import('@sentry/vue');

  try {
    Sentry.init({
      Vue,
      dsn,
      environment: process.env.ENVIRONMENT,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        new Sentry.Replay(),
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      ignoreErrors:[
        'Network Error'
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^sso1(.*).trendmicro.com/, /^\//],
    });
  } catch (err) {
    sentryInitError = true;
    throw err;
  }
};

export const reportToSentry = (err, context) => {
  if (sentryInitError || !Sentry) {
    console.warn('Sentry not support in current platform');
    return;
  }

  if (!context) return Sentry.captureException(err);

  else Sentry.withScope(function(scope) {
    const { level, tag } = context;
    scope.setTag(tag?.key, tag?.value);
    scope.setLevel(level);

    Sentry.captureException(err);
  });
};

export const sendMessageToSentry = (msg, context) => {
  if (sentryInitError || !Sentry) {
    console.warn('Sentry not support in current platform');
    return;
  }

  if (!context) return Sentry.captureMessage(msg);

  else Sentry.withScope(function(scope) {
    const { level, tag, extra } = context;
    scope.setTag(tag?.key, tag?.value);
    scope.setLevel(level);
    if (extra && extra.length > 0) {
      extra.forEach(e => scope.setExtra(e?.name, e?.value))
    }

    Sentry.captureMessage(msg);
  });
};